import axios from "axios";
import Cookies from 'js-cookie';

export const checkAuth = async () => {
    try {
        const response = await axios.get(`${process.env.VUE_APP_API_URL}/auth/check`, {
            headers: { "Authorization": getToken() },
        });
        return {success: true, message: response};
    } catch (error) {
        return {success: false, message: error};
    }
};


export const login = async (username, password) => {
    try {
        const response = await axios.post(`${process.env.VUE_APP_API_URL}/auth/login`,  {username, password });
        const { token } = response.data;

        Cookies.set('token', token, { expires: 7 });
        return { success: true, message: response.data};
    } catch (error) {
        return {success: false, message: error};
    }
};

export const logout = async () => {
    try {
        await Cookies.remove('token');
        return { success: true};
    } catch (error) {
        return {success: false, message: error};
    }
};


export const getToken = () => {
    return Cookies.get('token');
};

export default {
    checkAuth,
    login,
    logout,
    getToken
};